import { render, staticRenderFns } from "./signupComponent.vue?vue&type=template&id=6e2ed2c9&scoped=true"
import script from "./signupComponent.vue?vue&type=script&lang=js"
export * from "./signupComponent.vue?vue&type=script&lang=js"
import style0 from "./signupComponent.vue?vue&type=style&index=0&id=6e2ed2c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2ed2c9",
  null
  
)

export default component.exports